module.exports = __webpack_public_path__ + "media/images/menu-icon-2d30b5d577eac820030b93c2bebb5d9b.png";